import { Suspense, useEffect, useMemo } from "react";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import { useDataFetch } from "../../../../hooks/useDataFetch2";
import { useColumnsPac } from "../utils/columnsPac";
import Tabla from "../../../../components/ui/materialui/serverSideTable";
import TableHeader from "../../../../components/ui/materialui/tableHeader";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { FormFiltersInterface } from "../interfaces/FormFiltersInterface";
import { exportExcel } from "../../../../utils/exportExcel";
import { descargarArchivoPacPat } from "../../../detalleMutuo/services/servicesReportes";
import { useLocation } from "react-router-dom";
import { TipoFuncionalidad } from "../../../../utils/enums";
import { PermissionGuard } from "../../../../components/auth/ProtectedRoute";

export const TablaPacComponent = ({ fechaUF, fechaCobro, diaDescuento }: FormFiltersInterface ) => {

    const location = useLocation();
    const typeFile = location.pathname.toLowerCase().trim().includes('pat') ? 'pat' : 'pac';
    const urlTabla = `siscred-api-reportes/v1/archivo-pac-pat/dividendos-vigentes-${typeFile}`;
    
    const params = useMemo(() => {
        const p = new URLSearchParams();
        p.set("fechaEmision", fechaCobro!.toISOString().split("T")[0]);
        p.set("fechaUF", fechaUF!.toISOString().split("T")[0]);
        p.set("diaCobro", String(diaDescuento!));
        return p;
    }, [fechaUF, fechaCobro, diaDescuento]);

    const dataTable = useDataFetch(
        urlTabla,
        params,
        true,
    );

    const { COLUMNS } = useColumnsPac({ controlTabla: dataTable });
    const columns = useMemo(() => COLUMNS, [dataTable]);

    useEffect(() => {
        const essentialParams = `fechaEmision=${fechaCobro?.toISOString().split("T")[0]}&fechaUF=${fechaUF?.toISOString().split("T")[0]}&diaCobro=${diaDescuento}`;
        
        if (!dataTable.params.toString().includes(essentialParams)) {
            dataTable.fetchData(0); // Resetear a página 1 y cargar nuevos datos
            
            dataTable.manejarCambiosFiltros("fechaEmision", fechaCobro!.toISOString().split("T")[0]);
            dataTable.manejarCambiosFiltros("fechaUF", fechaUF!.toISOString().split("T")[0]);
            dataTable.manejarCambiosFiltros("diaCobro", String(diaDescuento!));
        }
    }, [fechaUF, fechaCobro, diaDescuento]);

    const fileName = typeFile === 'pac' ? 'ArchivoPAC' : 'ArchivoPAT';

    const handleClickEmitir = async () => await descargarArchivoPacPat(fechaUF!, fechaCobro!, diaDescuento!, typeFile == 'pac' ? true : false);

    return (
        <CustomAccordion title={'Mutuos vigentes'} expandedDefault>
            <Suspense>
                <Tabla
                    columns={columns}
                    control={dataTable}
                    url={urlTabla}
                    titulo={
                        <TableHeader
                            title=""
                            control={dataTable}
                            button={
                                <MButton
                                    type="button"
                                    variant="contained"
                                    onClick={handleClickEmitir}
                                    startIcon={<SummarizeTwoToneIcon />}
                                    disabled={dataTable.data.length > 0 ? false : true}
                                >
                                    Emitir
                                </MButton>
                            }
                            buttonExport={
                                <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                <MButton
                                    type="button"
                                    variant="outlined"
                                    onClick={() => exportExcel(dataTable.data, columns, fileName)}
                                    startIcon={<SummarizeTwoToneIcon />}
                                >
                                    Exportar
                                </MButton>
                                </PermissionGuard>
                            }
                        />
                    }
                />
            </Suspense>
        </CustomAccordion>
    )
}
